import { Typography } from '@medely/web-components';
import { TextField } from '@medely/web-components/forms';
import React from 'react';
import { required } from 'core/utils/validation';

type TextFieldProps = {
  name: string;
  isRequired: boolean;
  withNameLabel?: boolean;
  label: string;
};

const Text = ({ name, isRequired, withNameLabel, label }: TextFieldProps) => {
  const handleChange = (e) => {
    e.preventDefault();
  };

  return (
    <>
      {withNameLabel && <Typography gutterBottom>{label}</Typography>}
      <TextField
        name={`${name}.value`}
        validate={isRequired ? required : undefined}
        InputProps={{
          onCopy: handleChange,
          onPaste: handleChange,
        }}
        multiline
        minRows={4}
      />
    </>
  );
};

export default Text;
